import { useLocation, useModel } from '@umijs/max';
import React from 'react';
import AppLoading from '@/components/AppLoading';
import { canAccessPathByMenuState, isMenuAccessPending } from '@/utils/menu';

/** 菜单加载完成前展示 loading（与 getInitialState 共用 AppLoading） */
const MenuLoadingGate: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { initialState } = useModel('@@initialState');
  const { pathname } = useLocation();

  if (
    !initialState ||
    initialState.loading ||
    isMenuAccessPending(initialState)
  ) {
    return <AppLoading />;
  }

  // 复用统一权限判断，保留其中明确放行的页面；未授权页面在跳转前也不挂载。
  if (
    initialState.currentUser &&
    !canAccessPathByMenuState(pathname, {
      menuData: initialState.menuData || [],
      rawMenuData: initialState.rawMenuData || [],
      menuDataLoaded: Boolean(initialState.menuDataLoaded),
      menuSource: initialState.menuSource || 'backend',
    })
  ) {
    return null;
  }

  return <>{children}</>;
};

export default MenuLoadingGate;
